import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AngularFireStorage} from '@angular/fire/storage';
import {GalleryModel} from '../../models/galleryModel';

import * as _ from 'underscore';
import {GalleriesService} from '../../service/galleries.service';

@Component({
  selector: 'app-gallery-modal',
  templateUrl: './gallery-modal.component.html',
  styleUrls: ['./gallery-modal.component.scss']
})
export class GalleryModalComponent implements OnInit {

  activeTabIndex: number = 0;
  selectedGallery: GalleryModel;
  form: FormGroup;
  startDate = new Date().getTime();
  @ViewChild('picker') datePicker;

  constructor(
    private fb: FormBuilder,
    private galleriesService: GalleriesService,
    private dialogRef: MatDialogRef<GalleryModalComponent>,
    private storage: AngularFireStorage,
    @Inject(MAT_DIALOG_DATA) room: GalleryModel) {

    this.selectedGallery = room;

    this.form = fb.group({
      title: [this.selectedGallery.title, Validators.required],
      imageUrl: [this.selectedGallery.imageUrl],
      imageUrlFilePath: [this.selectedGallery.imageUrlFilePath],
    });

    // this.galleriesService.selectedGallery.subscribe((selectedGallery) => {
    //   this.selectedGallery = selectedGallery;
    // });

  }


  ngOnInit() {

  }

  save() {

    if (!this.form.valid) {
      return;
    }

    if (this.selectedGallery.id) {
      this.galleriesService.editGallery({...this.selectedGallery, ...this.form.value});
    } else {
      this.galleriesService.createGallery({...this.form.value});
    }

    this.dialogRef.close(this.form.value);
  }

  close() {
    this.dialogRef.close();
  }

  onSelectedTabChanged(event) {
    this.activeTabIndex = event.index;
  }


  deleteCoverImage() {
    const fileRef = this.storage.ref(this.selectedGallery.imageUrlFilePath);
    fileRef.delete();
    this.selectedGallery.imageUrl = '';
    this.selectedGallery.imageUrlFilePath = '';
    this.galleriesService.editGallery(this.selectedGallery);
  }

  deleteGalleryItem(item) {
    const fileRef = this.storage.ref(item.imageUrlFilePath);
    fileRef.delete();
    this.selectedGallery.galleryImages = _.without(this.selectedGallery.galleryImages, item);
    this.galleriesService.editGallery(this.selectedGallery);
  }

  galleryImageUploadFinished(event) {

    if (this.selectedGallery.galleryImages && this.selectedGallery.galleryImages.length) {
      this.selectedGallery.galleryImages.push(event);
    } else {
      this.selectedGallery.galleryImages = [event];
    }

    if (this.selectedGallery.id) {
      this.galleriesService.editGallery(this.selectedGallery);
    }
  }


  onUploadFinished(event) {
    this.selectedGallery.imageUrl = event.imageUrl;
    this.selectedGallery.imageUrlFilePath = event.imageUrlFilePath;
    this.form.controls['imageUrl'].patchValue(event.imageUrl);
    this.form.controls['imageUrlFilePath'].patchValue(event.imageUrlFilePath);

    if (this.selectedGallery.id) {
      this.galleriesService.editGallery(this.selectedGallery);
    }
  }
}
